import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space } = theme

export const ConfirmationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  button {
    width: 100%;
    justify-content: center;
  }

  @media screen and (${media.tablet}) {
    flex-direction: row;
    justify-content: flex-end;
  }
`
